/*jshint esversion: 6 */
<template>
  <div class="fs-10 flex-container" v-bind:class="page == 'detail'?'text-red right float-right':'text-black center paddingb20'" v-if="content">
    <span class="badge fs-13 badge-round  badge-radius" :class="page == 'detail'?'badge-red':'badge-black'">{{content.day}}</span> 
    <span style="padding:0 2px">天</span> 
    <span class="badge fs-13 badge-round  badge-radius" :class="page == 'detail'?'badge-red':'badge-black'">{{content.hour}}</span> 
    <span style="padding:0 2px">:</span> 
    <span class="badge fs-13 badge-round  badge-radius" :class="page == 'detail'?'badge-red':'badge-black'">{{content.min}}</span> 
    <span style="padding:0 2px">:</span> 
    <span class="badge fs-13 badge-round  badge-radius" :class="page == 'detail'?'badge-red':'badge-black'">{{content.sec}}</span>
  </div>
</template>
<style lang="scss">

</style>
 <script>
  export default {
    data() {
        return {
          content: '',
        }
      },
      props: {
        diffTime: {
          type: Number,
          default: ''
        },
        endTime: {
          type: Number,
          default: ''
        },
        endText: {
          type: String,
          default: ''
        },
        page:{
          type:String,
          default:null
        },
        callback: {
          type: Function,
          default: ''
        }
      },
      ready() {
        this.countdowm();
      },
      methods: {
        countdowm() {
          let that = this;
          let timer=setInterval(function() {
            let t = that.endTime - (Date.now() - that.diffTime);
            if (t > 0) {
              let day = Math.floor(t / 86400000);
              let hour = Math.floor((t / 3600000) % 24);
              let min = Math.floor((t / 60000) % 60);
              let sec = Math.floor((t / 1000) % 60);
              day = day < 10 ? "0" + day : day;
              hour = hour < 10 ? "0" + hour : hour;
              min = min < 10 ? "0" + min : min;
              sec = sec < 10 ? "0" + sec : sec;
              let format = { };
              if (day > 0) {
                format = {
                  day:day,
                  hour:hour,
                  min:min,
                  sec:sec
                };
              }
              if (day <= 0 && hour > 0) {
                format = {
                  day:'00',
                  hour:hour,
                  min:min,
                  sec:sec
                };
              }
              if (day <= 0 && hour <= 0) {
                format = {
                  day:'00',
                  hour:'00',
                  min:min,
                  sec:sec
                };
              }
              that.content = format;
              // that.time=that.time-1000
            } else {
              clearInterval(timer);
              that.content = that.endText;
              that.$dispatch('timer-reload');
            }
          }, 1000);
        },
        _callback() {
          if (this.callback && this.callback instanceof Function) {
          }
        }
      }
  } </script>